module.exports={Earlier:"ANTERIOR",New:"NUEVO",NoAnnouncements:"No tiene anuncios"};